import { format, parseISO, isValid } from "date-fns";
import { DatesFormat } from "shared-types";
import { CheckoutType } from "config/common";

export const formatDateToDayMonthYear = (dateString: string): string => {
  const date = parseISO(dateString);

  if (isValid(date)) {
    return format(parseISO(dateString), DatesFormat.dayMonthYearFormat);
  }

  return "";
};

export const isAcceptedCheckoutType = (value: any): value is CheckoutType => {
  return Object.values(CheckoutType).includes(value);
};
